
export function getFileUrl(fileId: string | undefined) {
    if (!fileId) return '/';
    return 'https://cdn-assets.productfruits.com/' + fileId;
}